import Swiper from 'swiper/bundle';
import flatpickr from "flatpickr";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);
import 'swiper/css/bundle'
import './flatpickr_ko';
    
$(() => {
    // header
    let $data = $('.header').data('nav');
    $('.top-menu>li').removeClass('active').eq($data).addClass('active')
    if($data == 10) $('.page-header').css('height','400')

    $(".rsv-menu").on({
        click:() => $('.rsv-list').slideToggle(),
        mouseenter:() => $('.rsv-list').slideDown(), 
        mouseleave:() => $('.rsv-list').slideUp()
    });

    $(window).scroll(() => {
        let mainHeight = $('.main-wrapper, .page-header').innerHeight()
        $('.header, .top-btn').removeClass('active');
        if($(window).scrollTop() > mainHeight) $('.header, .top-btn').addClass('active');
    })

    var Swipers = [];
    $('.slide, .sub-slide').each(function(i) {
        var r_i = $(this).find('.swiper').attr('id');
        Swipers[i] = new Swiper('#'+r_i, {	
            loop: true,
            loopAdditionalSlides : 1,
            navigation: {
                nextEl: ".swiper-button-next."+r_i,
                prevEl: ".swiper-button-prev."+r_i,
            },
            pagination: {
                el: ".swiper-pagination."+r_i,
                clickable: true,
            },
        });
    })

    flatpickr("#gdate", {
        minDate: "today",
        dateFormat: "Y-m-d",
        locale: "ko",
    });

    $('#tel').on("keyup",function() {
        prev    = $(this).val();
        str     = prev.replace(/[^0-9]/g, "").replace(/(^02|^0505|^01.{1}|^0[0-9]{2})([0-9]+)?([0-9]{4})/,"$1-$2-$3").replace("--", "-");
        $(this).val(str);
    });

    $('.input_price').on('input', function() {
        var value = $(this).val().replace(/[^0-9]/g, '');
        $(this).val(value ? Number(value).toLocaleString() : '');
    });

    const formCheck = ($form) => {
        const $input = $form.find('input, select, textarea');
        let chk = false

        if ($form) {
            $($input).each((i,v) => {
                if(v.value === '' && $(v).attr('data-optional') != "skip" && $(v).attr('type') != "hidden") {
                    alert($(v).data('check'));
                    $(v).focus();
                    chk = false;
                    return false;
                } else{
                    chk = true;
                }
            });
        } 
        return chk;
    }

    $("input[type=checkbox]").change((e) => {
        $(e.currentTarget).val($(e.currentTarget).is(':checked') ? 'y' : '')
        if($(e.currentTarget).hasClass('check-it')){
            $(".check-it").toArray().every((v) => $(v).is(':checked')) ? $(".check-all").prop("checked", true) : $(".check-all").prop("checked", false)
        }
    })

    // 페이지 이동시 스크롤 이동
    const params = new URLSearchParams(window.location.search);

    const scrollArea = ($target, $subMenu = 50) => {
        const targetTop = $(`.${$target}`).offset().top - ($('.header').outerHeight()  + $subMenu);
        window.scrollTo({ top: targetTop, left: 0});
    }
    
    params.get('scroll') && scrollArea(params.get('scroll'));

    // <---- dining/facil ---->
    $(window).scroll(() => {
        $('.facil-banner').removeClass('active');
        if($(window).scrollTop() > 650) $('.facil-banner').addClass('active');
    })

    $(".facil-btn").click(() => {
        const $form = $('#sms');
        formCheck($form);

        const data = $form.serializeArray(),
            sendData = {};

        for (let i = 0; i < data.length; i++){
            sendData[data[i]['name']] = data[i]['value'];
        }

        fetch('/facilities/sms/store', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name=csrf-token]').attr('content'),
            },
            body: JSON.stringify(sendData),
        })
        .then((response) => response.json())
        .then((result) => {
            alert('안내문자가 발송되었습니다.')
            self.close();
        }) 
    })

    
    flatpickr("#fdate", {
        minDate: "today",
        dateFormat: "Y-m-d",
        locale: "ko",
    });

    $('.facil-wrap .info-btn').click((e) => {
        scrollArea($(e.currentTarget).data('area'))
    })

    // 속초횟집 팝업
    let popStr = localStorage.getItem('o2uDining') 
    let popChk = !popStr || popStr != "" && dayjs().format('YYYY-MM-DD') > popStr ? true : false
    popChk ? $('.diningPopup').show() : $('.diningPopup').hide()

    let oneday = dayjs().format('YYYY-MM-DD');
    $('.diningPopup .btn-close').click(() => {
        if($('#today').is(':checked')){
            localStorage.setItem('o2uDining', oneday)
            $('.diningPopup').hide()
        }
    })

    // <---- group ---->
    $('.group-wrap .area-btn').click((e) => {
        scrollArea('area_contact')
    })
    $('.courseTab>li').click((e) => {
        $('.courseTab>li').removeClass('on').eq($(e.currentTarget).index()).addClass('on')
        $('.courseList>li').removeClass('on').eq($(e.currentTarget).index()).addClass('on')
    })
    $('.group-qna .f-q').click((e) => $(e.currentTarget).toggleClass('on').siblings($('.f-a')).toggleClass('on'))

    $('.person input').keyup(function() {
        let value1 = $('#man').val();
        let value2 = $('#woman').val();
        $('#all').val(+value1 + +value2);
    })

    $(".group-btn").click(() => {
        const $form = $('#grpform');
        formCheck($form);
        //     if (grecaptcha.getResponse() == ""){
        //     alert("'로봇이 아닙니다.'를 체크해주세요.");
        //     return;
        // } else {
        //     $("input[name='robot_check']").val("Y");
        // }
    })

    // <---- reserveclub ---->
    // let params = new URLSearchParams(window.location.search);
    let slideNum = params.get('slideNum')
    let bullet = ['리저브 클럽 29', '리저브 클럽 49', '리저브 클럽 99'];
    var rsvSwiper = new Swiper('.rsv-slide .swiper',{
        initialSlide: slideNum ? +slideNum : 0,
        loop: true,
        loopAdditionalSlides : 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            bulletClass:"custom-bullet",
            bulletActiveClass: "custom-bullet-active",
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + bullet[index] + "</span>";
            },
        },
        on: {
            init : (e) => {
                $('.club-wrap .info').hide()
                $('.club-wrap .info').eq(e.realIndex).show()
            },
            slideChange : (e) => {
                $('.club-wrap .info').hide()
                $('.club-wrap .info').eq(e.realIndex).show()
            },
        },
    });

    $('.club-wrap .fold-tit').click((e) => $(e.currentTarget).siblings('.fold-cnt').slideToggle())

    $('.club-wrap .table-wrap .table [class^=tab]').click((e) => {
        rsvSwiper.slideTo(+$(e.currentTarget).index() -1)
    })

    if($(".club-wrap .swiper-pagination").length){
        const $rsvTab = $(".swiper-pagination");
        const headerHeightWeb = $(".header").innerHeight();
        let initialOffset = $rsvTab.offset().top;
        const updateSticky = () => {
            $rsvTab.toggleClass("active", $(window).scrollTop() >= initialOffset + headerHeightWeb);
        };
        
        $(window).on("scroll resize", () => {
            updateSticky();
        }).trigger("resize");
        
        updateSticky();
    }

    // faq
    let current = 1;
    $('.pagination-wrap li').on('click', (e) => {
        let endpage = 2;
        let $item = $(e.currentTarget);
        let $id = $item.attr("id");
        let selected= $item.text();
        
        if ($id === "prev") selected = (current - 1 < 1 ) ? 1 : current - 1;
        else if ($id === "next") selected= (current + 1 > endpage + 1) ? current + 1 : endpage;
        else if ($id === "last") selected= endpage;
        else if ($id === "first") selected= 1;
        else selected= Number(selected);
        current = selected;
    
        $(".pagination-wrap li").removeClass('active')
        $(".reservePopup .faq-wrap").hide()
        $(".pagination-wrap li").eq(selected + 1).addClass('active')
        $(".reservePopup .faq-wrap").eq(selected - 1).show()
    });

    $('.faq-tit').click((e) => {
        let $this = $(e.currentTarget)
        let $thisInfo = $this.siblings('.faq-desc')
        if($this.hasClass('on')){
            $this.removeClass('on')
            $thisInfo.slideUp()
        }else{
            $thisInfo.slideUp()
            $('.faq-tit').removeClass('on')
            $('.faq-desc').slideUp()
            $this.addClass('on')
            $thisInfo.slideDown()
        }
    })

    // qna
    $('.reservePopup .cancel').click((e) =>{
        $('form').each((i,v) => v.reset())
        $('.reservePopup textarea').text('')
    })
    $('.reservePopup .confirm').click((e) =>{
        let $form = $(e.currentTarget).closest('.reservePopup');
        const chk = formCheck($form)
        if(chk == true) {
            //alert($(e.currentTarget).data('alert'));
            // $form.submit()
        }
    })

    $('.btnAsk').click((e) => {
        $('#ask #section').val($(e.currentTarget).data('type'))
        $('#ask #section').trigger('change'); 
    })
    
    $("#ask #section").change((e) =>{
        let qaType = $(e.currentTarget).find(":selected").val()
        let cnt = `고객 고유번호 (카드앞면 알파벳 및 번호) : \n숙박권 (사용할 숙박권 뒷면 알파벳 및 번호) :\n객실타입 :\n인원수 (4인기준, 초과시 1박 인당 3만원) :\n입실일 :\n퇴실일 :\n문의 내용 :\n\n※ 사용불가일 : 공휴일 및 연휴 휴일전날, 징검다리연휴, 성수기, 특정일, 마감일 (변동될수있음)\n※ 모든내용 미 기재시 자동 문의 취소됩니다`
        $('#ask textarea').text(qaType === 'a' ? '' : cnt)
    })

    $('.guide-wrap .tab').click((e) => {
        $('.guide-wrap .tab').removeClass('active')
        let tabidx = $(e.currentTarget).addClass('active').index()
        $('.guide-wrap .guide').each((i,v) => i === tabidx ? $(v).show() : $(v).hide())
    })

    // <---- booking ---->
    // 옵션 - + 버튼
    const UpDown = (e) => {
        let numInput = $(e.currentTarget).siblings('input')
        let numInputVal = +(numInput.val())
        numInputVal = numInputVal + $(e.currentTarget).data('calc')
        numInputVal < 0 ? numInput.val(0) : numInput.val(numInputVal)
    }

    // 달력
    let dayweek = ['일', '월', '화', '수', '목', '금', '토']
    let today = dayjs()
    let chkin = dayjs().format('YYYY-MM-DD')
    let chkout = dayjs().add(1, 'day').format('YYYY-MM-DD')
    const genCalendar = (today, body, type = 'non') => {
        const $calBody = $(body).find('.container');
        const $calTitle = $(body).find('.date-title');
        let now = dayjs(today)
        let firstDay = now.startOf("month").get('day');//달의 첫 요일
        let lastdate = now.endOf("month").get('date');//달의 마지막 일 28 or 30 or 31
        $($calTitle).find('span').text(`${now.get('y')}년 ${now.get('M')+1}월`)
        $calBody.empty();
        
        let html = '';
        let day = 1;
        
        $(html).appendTo($calBody)

        for(let i = 0; i < 42; i++){
            let calDay = `${now.format('YYYY-MM')}-${day < 10 ? '0' + day : day}`
            let dayCk = firstDay <= i && lastdate >= day
            $("<div class='day'>")
            .attr('data-dt',dayCk ? calDay : '' ) //data-dt 날짜 저장
            .addClass(dayjs(calDay).isBefore(dayjs().format('YYYY-MM-DD')) && dayCk ? 'off' : '' ) //오늘날짜 이전 off 추가
            .addClass(calDay === chkin && dayCk ? 'chkin' : '') //오늘 or 선택 날짜 chkin 추가
            .addClass(dayjs(calDay).isBetween(chkin, chkout) && dayCk ? 'slt' : '') //slt 클래스 추가
            .addClass(calDay === chkout && dayCk ? 'chkout' : '') //chkout 추가
            .addClass(dayjs(calDay).get('day') === 0 && dayCk ? 'sun' : dayjs(calDay).get('day') === 6 && dayCk  ? 'sat' : '' ) // 토,일 추가
            .html(dayCk ? day < 10 ? '0' + day++ : day++ : '')
            .append(dayCk ?  type === 'non' ? '' : '<span class="prc">10,000</span>' : '')
            .appendTo($calBody)
        }
        return html;
    }

    const dayClick = (e) =>{
        let $curTarget = $(e.currentTarget)
        let $cnt = $($curTarget).parents('.popup-cnt')
        let $day = $($cnt).find('.day')
        let chkinDT  = $($cnt).find('.day.chkin').data('dt')
        let curDT = $curTarget.data('dt')
        if(!$curTarget.hasClass('off') && $curTarget.text()){
            // 체크아웃 선택시 
            if($($cnt).find('.day.chkin').length > 0 && $($cnt).find('.day.chkout').length == 0 && dayjs(chkinDT).isBefore(curDT)) { //체그아웃 존재 하지않고 선택한 날짜가 체크인 이후일 경우
                dayjs(curDT).diff(dayjs(chkinDT), 'd') > 15 ?
                alert('해당상품은 15박이상 예약불가능합니다.')
                : $($cnt).find($('.off')).toArray().every(v => !dayjs($(v).data('dt')).isBetween(chkinDT, curDT)) ? //선택날짜중에 마감일 체크
                $day.each((i, v) => {
                    $(v).addClass(dayjs($(v).data('dt')).isBetween(chkinDT, curDT) ? 'slt' : '') //선택한 날짜들 slt 추가
                    $curTarget.addClass('chkout')
                    chkout = curDT  
                })
                : alert('이용기간 중 마감날짜가 포함되어 있습니다.')
                setDay(chkinDT, chkout)
            }else{//체크인 선택시
                $day.removeClass('chkin chkout slt')
                $curTarget.addClass('chkin')
                chkin = curDT
                chkout = ''
            }
        }

        let chkinDay = `${chkinDT}(${dayweek[dayjs(chkinDT).get('d')]})`
        let chkoutDay = `${chkout}(${dayweek[dayjs(chkout).get('d')]})`
        let diffDay = `${dayjs(chkout).diff(dayjs(chkinDT), "day")}`

        if($($cnt).parents('.calendarScroll')){
            if(chkout === ''){
                $('.popup-title span').text('체크아웃 날짜를 선택해주세요.')
            }else{
                $('.popup-title span').text(`${chkinDay} ~ ${chkoutDay} / ${diffDay}박`)
            }
        }
    }

    const setDay = (chkin, chkout) => {
        let chkinDay = `${chkin}(${dayweek[dayjs(chkin).get('d')]})`
        let chkoutDay = `${chkout}(${dayweek[dayjs(chkout).get('d')]})`
        let diffDay = `${dayjs(chkout).diff(dayjs(chkin), "day")}`
        $('.booking-wrap .head-checkin .date').text(`${chkinDay}`)
        $('.booking-wrap .head-checkout .date').text(`${chkoutDay}`)
        $('.booking-wrap .tab-head .num').text(`${diffDay}박`)
        $('.popup-title span').text(`${chkinDay} ~ ${chkoutDay} / ${diffDay}박`)

        // pc
        $('.booking-wrap .tab-head .date p').text(`[${chkinDay}]`)
        $('.booking-wrap .tab .prd-chkin').val(chkin)
        $('.booking-wrap .tab .prd-chkout').val(chkout)
        $('.booking-wrap .tab .prd-night').val(diffDay)
    }

    setDay(chkin, chkout)
    
    // 웹 달력
    let calType = ''
    $('.btn-cal').click((e) => {
        let thisbtn = $(e.currentTarget).data('mode')
        calType =  $(e.currentTarget).data('type') || calType
        if(thisbtn){
            today = $(e.currentTarget).data('mode') === 'add' ? today.add(1, "M") : today.add(-1, "M") //이전 다음 달력 버튼 비교
        }else{
            today = dayjs(chkin)
        }
        genCalendar(today, '.calendar-wrap.prev', calType)
        genCalendar(today.add(1, "M"), '.calendar-wrap.next', calType)
        $('.calendar-wrap.prev .btn-cal').css('display',today.get('M') === dayjs().get('M')? 'none' : 'block')
        
        $('.popup-cnt .day').click((e) => dayClick(e))
    })

    $(".tab-head .btn-cal").trigger("click");

    $('.booking-wrap .prd-night').change((e) => {
        let pday = $('.tab.active .prd-chkin').val()
        let pnight = $(e.currentTarget).val()
        chkout = dayjs(pday).add(pnight, "day").format('YYYY-MM-DD')
        $('.prd-chkout').val(chkout)
        $('.booking-wrap .tab .prd-night').val(pnight)
    })
    
    $('.sideBanner.booking .btn-help').click((e) =>{
        const $form = $('#help');
        formCheck($form);
    })

    $('.booking-wrap .tab-list .tab').click((e) =>{
        if(!$(e.currentTarget).hasClass('closed')){
            $('.booking-wrap .tab-list .tab').removeClass('active')
            $(e.currentTarget).addClass('active').find('input[type=radio]').prop('checked', true);
        }else{
            alert('예약마감된 객실입니다.')
        }
    })

    const pkgCheck = (pkgTitle) =>{
        let $ckbox = pkgTitle.find('input[type=checkbox]').toArray();
        let prdCnt = pkgTitle.closest('.prd-cnt')
        
        if($ckbox.every((v) => !($(v).is(':checked')))){
            prdCnt.find('.pkg-prc').hide()
            prdCnt.find('.prd-pay .total-pay').hide() 
            prdCnt.find('.prd-pay .pay').show()
        }else{
            prdCnt.find('.pkg-prc').show()
        }
    }
    
    $('.booking-wrap .prd-title').click((e) =>{
        $('.booking-wrap .pkg-tit').toArray().map(v => {
            $(v).find('input').prop('checked',false).val('')
            $(v).removeClass('active').next().removeClass('active')
            $(v).next().find('.opt-wrap .num input').toArray().map(opt => {
                $(opt).val(0)
            })
        })
        pkgCheck($('.booking-wrap .prd-title'))
        
        if($(e.currentTarget).hasClass('active')){
            $('.booking-wrap .prd-title').removeClass('active')
            $('.booking-wrap .prd-cnt').hide()
        }else{
            $('.booking-wrap .prd-title').removeClass('active')
            $('.booking-wrap .prd-cnt').hide()
            $(e.currentTarget).addClass('active')
            $(e.currentTarget).siblings('.prd-cnt').show()
        }
    })
    
    $('.booking-wrap .pkg-tit input[type=checkbox]').click((e) =>{
        let pkgCk = $(e.currentTarget)
        let pkgTitle = pkgCk.parent()
        let $optCkbow = pkgTitle.siblings().find('.opt-wrap .prc input').toArray()

        if(pkgCk.is(':checked')){
            pkgTitle.addClass('active').next().addClass('active')
        }else{
            pkgTitle.removeClass('active').next().removeClass('active')
            $optCkbow.map(v => $(v).val(0))
        }
        pkgCheck(pkgTitle)
    })

    $('.booking-wrap .opt-wrap .num .btn').click((e) => {
        UpDown(e);
        let $pkgnum = $('.booking-wrap .opt-wrap .prc input').toArray()
        let prdCnt = $(e.currentTarget).closest('.prd-cnt')
        if($pkgnum.some((v) => +$(v).val() > 0)){
            prdCnt.find('.prd-pay .total-pay').show()
            prdCnt.find('.prd-pay .pay').hide() 
        } else{
            prdCnt.find('.prd-pay .total-pay').hide() 
            prdCnt.find('.prd-pay .pay').show()
        }
    })

    $('.booking-wrap .gallery li').click((e)=> {
        $('.galleryPopup').show()
        let $gallery = $(e.currentTarget).closest('.gallery').prevUntil('.info-wrap')
        let num = $gallery.find('li').length
        let idx = $(e.currentTarget).index() + num
        Swipers[0].slideTo(idx)
    })

    $('.reservation-wrap .pay-wrap input[type=radio]').change((e) => {
        let pay = $(e.currentTarget).attr('id')
        $('.reservation-wrap .comment .comt').hide()
        $(`.reservation-wrap .comment .${pay}`).show()
        $(`.pay_va input`).attr('data-optional', pay === 'pay_va' ? '' : 'skip')
    })

    /**
     * 결제하기 버튼 클릭 시 처리
     */
    $(".reservation-wrap .btn-payment").click(() => {
        const $form = $('#rsv');
        const valide = formCheck($form);

        const plaform = $(".reservation-wrap .btn-payment").data('plaform');  //모바일/PC 분기

        if (valide == true) {
            if (plaform == 'mobile') {
                $('#stayname').val($('#reserve_name').val());
                $form.submit();
            } else {
                $('#reserve_name').val($('#stayname').val());
                $form.submit();
                // window.name = "reservation_02";
                // const payWin = window.open("/booking/paymentPopupPC", "payment", "toolbar=no,scrollbars=yes,directories=no,status=no,menubar=no,width=400,height=650,resizable=yes, top=50, left="+((screen.width - 450)/2)+"");
                // $form.attr({"target": "payment", "action": "/booking/paymentPopupPC"}).submit();
                // payWin.focus();
            }
        }
    })

    $(".reservation-wrap .check-all").change((e) => {
        $('.check-list input[type=checkbox]').each((i,v) =>{
            $(v).prop("checked",$(e.currentTarget).is(':checked'))
            $(v).val($(e.currentTarget).is(':checked') ? 'y' : '')
        })
    })

    $(window).scroll(() => {
        $('.sideBanner.booking').removeClass('active');
        if($(window).scrollTop() > 200) $('.sideBanner.booking').addClass('active');
    })

    // 예약 모바일 

    // 달력
    $('.booking-wrap .room-wrap .tab-head').click((e) => {
        $('.calendarScroll .calendar-wrap').each((i, v) => {
            genCalendar(dayjs().add(i, "M"), v)
            $(v).find('.day').each((i, v) => {if($(v).text() === '')$(v).css('background-color', '#fff')})
        })
        $('.popup-cnt .day').click((e) => dayClick(e))
    })
    $('.calendarScroll .close-btn, .calendarScroll .btn-choice').click((e) => {
        if(chkout ===''){
            alert('체크아웃 날짜를 선택하세요.')
        }else{
            $('#cal_m').hide();
        }
    })

    // 모바일 click이벤트 오류
    $('.booking-wrap .list-wrap .tab').on('touchend, mouseup',(e) => {
        if(!$(e.currentTarget).hasClass('closed')){
            $('.booking-wrap .list-wrap .choice-wrap').hide()
            $(e.currentTarget).find('.choice-wrap').show()
            $('.booking-wrap .list-wrap .tab').removeClass('active')
            $(e.currentTarget).addClass('active').find('input[type=radio]').prop('checked', true);
        }else{
            alert('예약마감된 객실입니다.')
        }
    })
    
    $('.reservation-wrap .paytype').click((e) => {
        $('.reservation-wrap .paytype').removeClass('active')
        $(e.currentTarget).addClass('active')
        $('.reservation-wrap input[name=pay_type]').val($(e.currentTarget).data('type'))
    })

    // -----------------------------------
    // 리저브 클럽 관련 javascript
    // -----------------------------------

    // 카드발급 요청
    $('#btn-reserve-club-card').on('click', function () {
        var name = $('#card_name').val();
        var tel = $('#card_phone').val();
        var email = $('#card_mail').val();

        var chk = $('#card_agree').is(':checked');

        if (name == '') {
            alert('이름을 입력해주세요.');
            $('#card_name').focus();
            return;
        }

        if (/^\d{10,11}$/.test(tel) == false) {
            alert('핸드폰번호를 정확하게 입력해주세요.');
            $('#card_tel').focus();
            return;
        }

        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) == false) {
            alert('이메일 주소를 정확하게 입력해주세요.');
            $('#card_email').focus();
            return;
        }

        if (chk == false) {
            alert('개인정보의 수집 및 이용에 동의해주세요.');
            return;
        }

        $('#cardform').submit();
    });

    // 명의개서 요청
    $('#btn-reserve-club-trans').on('click', function () {
        var name = $('#trn_name').val();
        var tel = $('#trn_phone').val();
        var email = $('#trn_mail').val();

        var chk = $('#trn_agree').is(':checked');

        if (name == '') {
            alert('이름을 입력해주세요.');
            $('#trn_name').focus();
            return;
        }

        if (/^\d{10,11}$/.test(tel) == false) {
            alert('핸드폰번호를 정확하게 입력해주세요.');
            $('#trn_tel').focus();
            return;
        }

        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) == false) {
            alert('이메일 주소를 정확하게 입력해주세요.');
            $('#trn_email').focus();
            return;
        }

        if (chk == false) {
            alert('개인정보의 수집 및 이용에 동의해주세요.');
            return;
        }

        $('#trnform').submit();
    });

    // 1:1 문의하기 "확인" 처리
    $('#btn-reserve-club-inquire').on('click', function () {
        var section = $('#section option:selected').val();
        var name = $('#inquire_name').val();
        var tel = $('#inquire_tel').val();
        var email = $('#inquire_email').val();
        var contents = $('#reserve-club-inquire-contents').val();

        var chk = $('#popup_agree').is(':checked');

        if (section == '') {
            alert('질문 분류를 선택해주세요.');   
            return;
        }

        if (name == '') {
            alert('이름을 입력해주세요.');
            $('#inquire_name').focus();
            return;
        }

        if (/^\d{10,11}$/.test(tel) == false) {
            alert('핸드폰번호를 정확하게 입력해주세요.');
            $('#inquire_tel').focus();
            return;
        }

        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) == false) {
            alert('이메일 주소를 정확하게 입력해주세요.');
            $('#inquire_email').focus();
            return;
        }

        if (chk == false) {
            alert('개인정보의 수집 및 이용에 동의해주세요.');
            return;
        }

        $('#rsvform').submit();
    });

    // -------------------------------------
    // 단체문의 시 필수 데이터 체크
    // -------------------------------------
    $('#btn-group-ask-run').on('click', function() {
        //필수 데이터 체크
        var name = $('#name').val();
        var tel1 = $('#tel1').val();
        var tel2 = $('#tel2').val();
        var tel3 = $('#tel3').val();
        var email = $('#email').val();

        if (name == '') {
            alert('예약자를 입력해 주세요.');
            $('#name').focus();
            return;
        }

        if (tel1 == '') {
            alert('연락처 앞 부분을 입력해 주세요.');
            $('#tel1').focus();
            return;
        }

        if (/^\d{2,3}$/.test(tel1) == false) {
            alert('연락처 앞 부분이 유효하지 않습니다.');
            $('#tel1').focus();
            return;
        }

        if (tel2 == '') {
            alert('연락처 중간 부분을 입력해 주세요.');
            $('#tel2').focus();
            return;
        }

        if (/^\d{4}$/.test(tel2) == false) {
            alert('연락처 중간 부분이 유효하지 않습니다.');
            $('#tel2').focus();
            return;
        }

        if (tel3 == '') {
            alert('연락처 마지막 부분을 입력해 주세요.');
            $('#tel3').focus();
            return;
        }

        if (/^\d{4}$/.test(tel3) == false) {
            alert('연락처 마지막 부분이 유효하지 않습니다.');
            $('#tel3').focus();
            return;
        }

        if (email == '') {
            alert('이메일을 입력해 주세요.');
            $('#email').focus();
            return;
        }

        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (regex.test(email) == false) {
            alert('이메일 형식이 유효하지 않습니다.');
            $('#email').focus();
            return;
        }

        //통과 후 form 전송
        $('#grpform').submit();
    });

    // 예약내역 조회
    $('.history-wrap .tab').on('click', 'li',(e) =>{
        let idx = $(e.currentTarget).index()
        $('.history-wrap .tab li').removeClass('active')
        $(e.currentTarget).addClass('active')
        
        $('.history-wrap .section>li').hide()
        $('.history-wrap .section>li').eq(idx).show()
    })

    $(".btn-copy").on("click", function() {
        const text = $(this).data("copy").trim();
        navigator.clipboard.writeText(text).then(() => alert('주소가 복사 되었습니다.\n원하는 곳에 붙여넣기 해주세요.'));
    });

    /**
     * 영수증발급/호텔바우처 클릭 이벤트 처리
     */
    $('.btn-receipt-voucher').on('click', function (e) {
        e.preventDefault();

        const type = $(this).data('type');
        const orderNo = $(this).data('no');

        const width = (type == 'voucher') ? 800 : 420;

        // 팝업 창 열기 (빈 새 창 생성)
        const popup = window.open('', 'popup', 'width='+width+',height=800');

        // 타입 별 action 지정
        const action = (type == 'voucher') ? '/booking/voucher' : '/booking/receipt';

        // 동적 폼 생성
        const form = $('<form>', { method: 'POST', action: action, target: 'popup' });

        // CSRF 토큰이 필요하면 여기에 추가
        form.append($('<input>', { type: 'hidden', name: '_token', value: $('meta[name="csrf-token"]').attr('content') }));

        // 주문번호 추가
        form.append($('<input>', { type: 'hidden', name: 'order_no', value: orderNo }));

        $('body').append(form);
        form.submit();
    });

    /**
     * 호텔바우처 메일 발송 처리
     */
    $('#btn-voucher-send-mail').on('click', function (e) {
        e.preventDefault();

        const orderNo = $(this).data('no');

        $.ajax({
            url: '/booking/voucherSendmail',
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {order_no: orderNo},
            dataType: 'json',
            success: function(response) {
                if (response.res == '200') {
                    alert('메일이 발송되었습니다.');
                } else {
                    alert('메일 발송이 실패했습니다.\r\n잠시후에 다시 시도해주세요.');
                }
            },
            error: function(xhr, status, error) {
                alert('메일 발송이 실패했습니다.\r\n잠시후에 다시 시도해주세요.');
            }
        });
    });

});